import { BaseState } from '@/store/base-state';
import { TableFilterItem, PaginationProps, TableOptions } from '@/types';
import { default_client } from '../services';
import { Clients } from '../types';

export default class ClientsState extends BaseState {
  clients: Clients.ClientListItem[] = [];
  clients_loading = false;

  cities: string[] = [];
  organization_types: TableFilterItem[] = [];

  filters: Clients.RequestFilters = {
    search: null,
    city: null,
    organization_types: null,
    is_active: false,
  };

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['company_name'],
    sortDesc: [true],
  };

  current_client = default_client();

  clients_to_add: Clients.ClientToAddItem[] = [];
  clients_to_add_loading = false;

  clients_to_add_filters: Clients.ClientsToAddRequestFilters = {
    search: '',
  };

  clients_to_add_table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['company_name'],
    sortDesc: [true],
  };

  clients_to_add_pagination_props: PaginationProps = this.create_pagination_props;
}
